<template>
  <line
    :x1 = "line.x1 * getMagScale"
    :y1 = "getSlopeSegmentStartY"
    :x2 = "line.x2 * getMagScale"
    :y2 = "getSlopeSegmentEndY"
    :style = "getLineColor"
  />
</template>

<script>
import { useSegmentStore } from '@/store/SegmentStore';
import { usePipeStore } from '@/store/PipeStore';

export default {
  name: 'CompositeLine',
  props: [
    'line',
    'num'
  ],
  data () {
    return {
      'mySprinklers': []
    };
  },
  mounted () {
    this.getMySprinklers();
  },
  updated () {
    this.getMySprinklers();
  },
  computed: {
    getLineColor () {
      return 'stroke:' + this.$props.line.color + ';stroke-linecap:round;stroke-width:' + this.getLineWidth;
    },
    getMagScale () {
      return useSegmentStore().getMagScale;
    },
    getLineWidth () {
      let pipe = usePipeStore().getPipeById(this.$props.line.pipeId);
      return pipe ? pipe.nominal_dia_m * 150 : 2; // pipe.nps * .5;
    },
    getLineXLength () {
      return this.line.x2 - this.line.x1;
    },
    getLineYHeight () {
     return (this.getSlopeSegmentStartY* 1) - (this.getSlopeSegmentEndY* 1);
      // return this.line.y1 - this.line.y2;
    },
    getMaxRatio () {
      return  useSegmentStore().getMaxRatio ;
    },
    getSlopeSegmentStartY () { // index
      return this.line.y1 ;
    },
    getSlopeSegmentEndY () { // index
      return this.line.y2;
    }
  },
  methods: {
    getY1 ( sprinkler ) {

      let sprinklerStartX = (sprinkler.attributes.x2.value - (this.$props.line.x1 * this.getMagScale)) / (this.getLineXLength * this.getMagScale);
      return (this.$props.line) ?  this.getSlopeSegmentStartY - this.getLineYHeight*sprinklerStartX : 0;

     },
    getMySprinklers () {
      let sprinklers = Array.from(document.getElementsByClassName('editor-sprinkler'));
      this.mySprinklers = sprinklers.filter((sprinkler) => {
        let sprinklerX1 = sprinkler.attributes.x1.value / this.getMagScale;
        if ( sprinklerX1 >= (this.$props.line.x1) && sprinklerX1 <= (this.$props.line.x2) ) { return sprinkler; }
      });
      let height = 0;
      for (let a = 0; a < this.mySprinklers.length; a++) {
        let sprinkler = this.mySprinklers[a];
        sprinkler.attributes.style.value = 'stroke:' + this.$props.line.color + ';';
        let newY = this.getY1(sprinkler, height);
        if (isNaN(newY)) { newY = 0; }
        let y1 = (newY);
        sprinkler.attributes.y1.value =  (y1);
        sprinkler.attributes.y2.value = (y1 - 25);
      }
    }
  }
};
</script>